import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth/authentication.service';
import * as Sentry from '@sentry/angular';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	private authenticationService = inject(AuthenticationService);

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((err) => {
				const isRefreshTokenRequest = req.url.includes('/auth/refreshtoken');
				if (!isRefreshTokenRequest && (err.status === 401 || err.status === 403)) {
					this.authenticationService.refresh(err.status);
				} else if (err.status === 500 || err.status === 502) {
					Sentry.captureException(err);
				}
				let error = typeof err.error === 'string' ? err.error : err.error?.message;
				if (err.status === 502 || err.status === 504) error = 'Sorry, server is temporary unavailable. Please try again later.';
				return throwError(error || 'Error');
			})
		);
	}
}
